<template>
  <div class="ca-page">

    <!-- Hero -->
    <div class="ca-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-shield-account-outline</v-icon>
        </v-avatar>
        <div>
          <div class="ca-hero__title">Cargos y Roles del Sistema</div>
          <div class="ca-hero__sub">Configuración de permisos y módulos por cargo</div>
        </div>
      </div>
    </div>

    <div class="ca-body">

      <v-alert type="warning" dense outlined class="mb-4" style="font-size:0.82rem;">
        <strong>ADVERTENCIA:</strong> Los datos de esta tabla son muy sensibles y delicados para el sistema.
        Si usted no está capacitado para el uso de este módulo, por favor no realice ningún cambio.
      </v-alert>

      <!-- Toolbar -->
      <v-card outlined class="ca-toolbar-card mb-4">
        <v-card-text class="py-2 px-4 d-flex align-center" style="gap:10px;">
          <v-chip x-small :color="cargos.length ? 'indigo lighten-5' : 'grey lighten-3'"
            class="indigo--text text--darken-2 font-weight-medium">
            {{ cargos.length }} cargo{{ cargos.length !== 1 ? 's' : '' }}
          </v-chip>
          <v-spacer />
          <Alertas ref="alertar" />
        </v-card-text>
      </v-card>

      <!-- Tabla -->
      <v-card outlined class="ca-table-card">
        <v-data-table
          :headers="headers"
          :items="cargos"
          hide-default-footer
          disable-pagination
          dense
          class="ca-table"
          no-data-text="Sin cargos registrados."
          @click:row="editarCargo"
          :item-class="() => $store.state.CARGO.id == 1 ? 'ca-row-clickable' : ''"
        >
          <template v-slot:[`item.menuscargo`]="{ item }">
            <v-chip x-small label color="indigo lighten-5"
              class="indigo--text text--darken-2 font-weight-medium">
              {{ item.menuscargo.length }}
            </v-chip>
          </template>
        </v-data-table>
      </v-card>

    </div>

    <notifications group="auth" position="bottom right" />
  </div>
</template>

<script>
import gql from 'graphql-tag';
import { parseJsonError } from '@/components/Utils.js';
import Alertas from '@/components/AAlertas.vue';

export default {
  components: { Alertas },
  data() {
    return {
      cargos: [],
      headers: [
        { text: 'ID',      value: 'id',          width: 80 },
        { text: 'Nombre',  value: 'nombre' },
        { text: 'Módulos', value: 'menuscargo',   width: 100, sortable: false },
      ],
    };
  },
  methods: {
    editarCargo(c) {
      if (this.$store.state.CARGO.id == 1) {
        window.sessionStorage.setItem('xcargoedit', JSON.stringify(c));
        this.$router.push({ name: 'cargoedit' });
      }
    },
    async getDatos() {
      this.$refs.alertar.cargando();
      const sql = gql`query{ getCargos{id,nombre,descripcion,menuscargo{idmenu}} }`;
      await this.$apollo.query({ query: sql })
        .then((data) => {
          this.cargos = data.data.getCargos;
          this.$refs.alertar.reset();
        })
        .catch((error) => {
          this.$notify(parseJsonError(error, 'getCargos'));
        });
    },
  },
  mounted() {
    this.getDatos();
  },
};
</script>

<style scoped>
.ca-page { min-height: 100vh; background: #f5f7fa; }

.ca-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.ca-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.ca-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.ca-body { padding: 20px 24px; }

.ca-toolbar-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }

.ca-table-card { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }

.ca-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 6px 12px !important;
}
.ca-table >>> tbody tr:hover { background: #f0f4ff !important; }
.ca-table >>> tbody tr td {
  font-size: 0.82rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 5px 12px !important;
  vertical-align: middle;
}
.ca-table >>> tbody tr.ca-row-clickable { cursor: pointer; }
</style>
